<template>
  <div class="redact_container">
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      highlight-current-row
      @selection-change="handleSelectionChange"
      stripe
      border
      v-loading="tableLoading"
    >
      <el-table-column type="selection" width="55" align="center">
      </el-table-column>
      <el-table-column type="index" label="序号" width="55" align="center">
      </el-table-column>
      <el-table-column property="checkTimeStr" label="检测/评定日期">
      </el-table-column>
      <el-table-column property="checkType" label="检测/评定类别">
      </el-table-column>
      <el-table-column property="checkOrgName" label="检测/评定单位">
      </el-table-column>
      <el-table-column property="checkSn" label="报告编号"> </el-table-column>
      <el-table-column property="checkUserName" label="登记人员">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="goRedact(scope.row)"
            >检测报告</el-button
          >
          <el-button type="text" @click="goDetele(scope.row)">结论</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging_box">
      <!--  :current-page="currentPage4" -->
      <el-pagination
        @size-change="handleSizeChange"
        background
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <v-addCarAccident :dialogShow.sync="addCarAccidentShow"></v-addCarAccident>
  </div>
</template>

<script>
import addCarAccident from "./tabDialog/addCarAccident.vue";
export default {
  name: "",
  data() {
    return {
      tableData: [],
      total: 0,
      tableLoading: false,
      addCarAccidentShow: false,
      multipleSelection: [],
    };
  },
  components: {
    "v-addCarAccident": addCarAccident,
  },
  props: {
    netId: Number,
  },
  created() {},
  methods: {
    getList() {
      this.tableLoading = true;
      this.$http.getCarCheckList({ id: this.netId }).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.info(res.msg);
        }
      });
    },
    addClick() {
      this.addCarAccidentShow = true;
    },
    handleSelectionChange(e) {
      this.multipleSelection = val;
    },
    goRedact(row) {},
    goDetele(row) {},
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style lang="less" scoped>
@import "./redact.less";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carTechnology_component/redact_carEvaluate.vue